module.exports = "<span class=\"geo-arrow\"></span>\n<svg><use xlink:href='../../assets/images/icons/icons.svg#icon-despachos'/></svg>\n<span>Seguros</span>\n<div class=\"geo-submenu\">\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + segurosRoute + '/' + seguradorasRoute]\" routerLinkActive=\"active\">{{seguradorasModule.plural}}</a>\n    <a class=\"geo-submenu__item\" [routerLink]=\"['./' + despachosRoute + '/' + segurosRoute]\" [routerLinkActiveOptions]=\"{ exact: true }\" routerLinkActive=\"active\">{{segurosModule.plural}}</a>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/despachos/shared/despacho-seguros-menu/despacho-seguros-menu.component.html
 ** module id = 1038
 ** module chunks = 0
 **/